import React, { ReactNode } from "react";
import {
  FieldValues,
  Path,
  RegisterOptions,
  useController,
} from "react-hook-form";

import {
  StyledBEImage,
  StyledImageWrapper,
  StyledRadioButtonWrapper,
  StyledRequired,
} from "./FormSlider.style";
import { ErrorMessage } from "../ErrorMessage";
import { StyledLdLabelSlider } from "../FormInput/FormInput.style";
import { BASE_PATH } from "../../config";

export const validateValueIsNotEmpty = (value: unknown) => {
  if (Array.isArray(value)) {
    return !!value.length;
  }
  if (typeof value === "string") {
    return !!value.trim();
  }
  return !!value;
};

type FormSliderProps<FormData extends FieldValues> = {
  max: number;
  min: number;
  name: Path<FormData>;
  label?: ReactNode;
  beWindow?: any;

  rules?: Exclude<
    RegisterOptions,
    "valueAsNumber" | "valueAsDate" | "setValueAs"
  >;
  disabled?: boolean;
  onChange?: any;
};

function FormSlider<FormData extends FieldValues>({
  name,
  label,
  beWindow = false,
}: FormSliderProps<FormData>) {
  const {
    fieldState: { error },
  } = useController({
    name,
  });

  return (
    <StyledRadioButtonWrapper data-testid="slider">
      <StyledRequired>{label}</StyledRequired>
      {beWindow && <BEWindowImage type={beWindow} />}
      <ErrorMessage
        testId={`${name}-input-error-message-required`}
        errorMessage={error?.message}
      />
    </StyledRadioButtonWrapper>
  );
}

export { FormSlider };

const BEWindowImage = ({ type }: any) => {
  const imagePath = `${BASE_PATH}/images/base_edit_window_${type}.png`;
  return (
    <StyledImageWrapper>
      <StyledBEImage src={imagePath} />
      <StyledLdLabelSlider mLeft={type}>Base Editing Window</StyledLdLabelSlider>
    </StyledImageWrapper>
  );
};